/**
 * MobileHeaderMenu Store - Zustand store with individual selectors
 * Manages Sheet menu open/close state for mobile header
 * Following individual selectors pattern (per zustand-patterns.md)
 */

import { create } from 'zustand';

// ============================================================================
// Store State
// ============================================================================

interface MobileHeaderMenuState {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  toggle: () => void;
  close: () => void;
}

// ============================================================================
// Store
// ============================================================================

const useMobileHeaderMenuStore = create<MobileHeaderMenuState>((set) => ({
  isOpen: false,

  setIsOpen: (isOpen) => set({ isOpen }),

  toggle: () => set((state) => ({ isOpen: !state.isOpen })),

  close: () => set({ isOpen: false }),
}));

// ============================================================================
// Individual Selector Hooks (per zustand-patterns.md)
// ============================================================================

export const useMobileHeaderMenuIsOpen = () =>
  useMobileHeaderMenuStore((state) => state.isOpen);

export const useSetMobileHeaderMenuIsOpen = () =>
  useMobileHeaderMenuStore((state) => state.setIsOpen);

export const useToggleMobileHeaderMenu = () =>
  useMobileHeaderMenuStore((state) => state.toggle);

export const useCloseMobileHeaderMenu = () =>
  useMobileHeaderMenuStore((state) => state.close);

// For testing only
export const _resetMobileHeaderMenuStore = () =>
  useMobileHeaderMenuStore.setState({ isOpen: false });
